// ─── RBAC: Permissões do Sistema ──────────────────────────────────────────────
// Formato: "modulo:acao"
// Compartilhado entre server e client.

// ── Dashboard ────────────────────────────────────────────────────────────────
export const P_DASHBOARD_VIEW = "dashboard:view";

// ── Inbox / Atendimento ──────────────────────────────────────────────────────
export const P_INBOX_VIEW = "inbox:view";
export const P_INBOX_VIEW_ALL = "inbox:view_all";
export const P_INBOX_SEND_MESSAGE = "inbox:send_message";
export const P_INBOX_SEND_MEDIA = "inbox:send_media";
export const P_INBOX_ASSIGN = "inbox:assign";
export const P_INBOX_MANAGE_LABELS = "inbox:manage_labels";
export const P_INBOX_MANAGE_REMINDERS = "inbox:manage_reminders";
export const P_INBOX_GENERATE_AI_REPLY = "inbox:generate_ai_reply";

// ── Contatos ─────────────────────────────────────────────────────────────────
export const P_CONTACTS_VIEW = "contacts:view";
export const P_CONTACTS_VIEW_DETAILS = "contacts:view_details";
export const P_CONTACTS_CREATE = "contacts:create";
export const P_CONTACTS_EDIT = "contacts:edit";
export const P_CONTACTS_DELETE = "contacts:delete";
export const P_CONTACTS_BULK_IMPORT = "contacts:bulk_import";
export const P_CONTACTS_BULK_DELETE = "contacts:bulk_delete";
export const P_CONTACTS_DELETE_ALL = "contacts:delete_all";
export const P_CONTACTS_EXPORT = "contacts:export";
export const P_CONTACTS_MANAGE_TAGS = "contacts:manage_tags";
export const P_CONTACTS_MANAGE_SEGMENTS = "contacts:manage_segments";
export const P_CONTACTS_LEAD_SCORING = "contacts:lead_scoring";

// ── WhatsApp ─────────────────────────────────────────────────────────────────
export const P_WHATSAPP_VIEW_BROADCASTS = "whatsapp:view_broadcasts";
export const P_WHATSAPP_CREATE_BROADCAST = "whatsapp:create_broadcast";
export const P_WHATSAPP_EDIT_BROADCAST = "whatsapp:edit_broadcast";
export const P_WHATSAPP_SEND_BROADCAST = "whatsapp:send_broadcast";
export const P_WHATSAPP_DELETE_BROADCAST = "whatsapp:delete_broadcast";
export const P_WHATSAPP_MANAGE_TEMPLATES = "whatsapp:manage_templates";
export const P_WHATSAPP_SYNC_TEMPLATES = "whatsapp:sync_templates";
export const P_WHATSAPP_MANAGE_FLOWS = "whatsapp:manage_flows";
export const P_WHATSAPP_MANAGE_AUTOMATIONS = "whatsapp:manage_automations";
export const P_WHATSAPP_MANAGE_SEQUENCES = "whatsapp:manage_sequences";
export const P_WHATSAPP_AUTO_ASSIGNMENT = "whatsapp:auto_assignment";
export const P_WHATSAPP_KNOWLEDGE_BASE = "whatsapp:knowledge_base";
export const P_WHATSAPP_AI_INSIGHTS = "whatsapp:ai_insights";
export const P_WHATSAPP_SANDBOX = "whatsapp:sandbox";
export const P_WHATSAPP_OPTIN = "whatsapp:optin";

// ── Email Marketing ──────────────────────────────────────────────────────────
export const P_EMAIL_VIEW_CAMPAIGNS = "email:view_campaigns";
export const P_EMAIL_CREATE_CAMPAIGN = "email:create_campaign";
export const P_EMAIL_EDIT_CAMPAIGN = "email:edit_campaign";
export const P_EMAIL_SEND_CAMPAIGN = "email:send_campaign";
export const P_EMAIL_SEND_TEST = "email:send_test";
export const P_EMAIL_DELETE_CAMPAIGN = "email:delete_campaign";
export const P_EMAIL_MANAGE_TEMPLATES = "email:manage_templates";
export const P_EMAIL_MANAGE_FLOWS = "email:manage_flows";
export const P_EMAIL_AI_TOOLS = "email:ai_tools";
export const P_EMAIL_BRAND_VOICE = "email:brand_voice";
export const P_EMAIL_EXPORT_REPORTS = "email:export_reports";

// ── Relatórios ───────────────────────────────────────────────────────────────
export const P_REPORTS_VIEW_WHATSAPP = "reports:view_whatsapp";
export const P_REPORTS_VIEW_EMAIL = "reports:view_email";
export const P_REPORTS_VIEW_INBOX = "reports:view_inbox";
export const P_REPORTS_VIEW_AI_INSIGHTS = "reports:view_ai_insights";
export const P_REPORTS_MESSAGE_TRACER = "reports:message_tracer";

// ── Configurações ────────────────────────────────────────────────────────────
export const P_SETTINGS_VIEW = "settings:view";
export const P_SETTINGS_EDIT_WHATSAPP = "settings:edit_whatsapp";
export const P_SETTINGS_EDIT_EMAIL = "settings:edit_email";
export const P_SETTINGS_MANAGE_WEBHOOKS = "settings:manage_webhooks";
export const P_SETTINGS_OFFICE_HOURS = "settings:office_hours";
export const P_SETTINGS_QUICK_REPLIES = "settings:quick_replies";
// Comportamento do robô (max_bot_attempts, categorias de notificação do
// admin). Separado de EDIT_WHATSAPP porque não é credencial — é política
// de atendimento. Mesma role hoje recebe os dois, mas a separação permite
// granularidade futura sem migrar consumidores.
export const P_SETTINGS_EDIT_BOT = "settings:edit_bot";
// Tokens de acesso do servidor MCP. Separado de MANAGE_WEBHOOKS porque um token
// MCP herda TODAS as permissões de quem o cria — quem pode emitir token está
// materializando o próprio nível de acesso numa credencial de longa duração.
// Como o token nunca excede o RBAC do dono, é seguro conceder a perfis comuns:
// marketing e comercial recebem por padrão; atendente fica opt-in do admin.
// Remover a permissão do perfil derruba na hora os tokens já emitidos
// (checagem por requisição em server/mcp/http.ts).
export const P_SETTINGS_MCP_TOKENS = "settings:mcp_tokens";

// ── IA (BYOK + Agentes + Routing Engine) ────────────────────────────────────
// F1.1+ — gerencia credenciais de LLM por tenant (BYOK), agentes especialistas
// e o Routing Engine. Separado de WHATSAPP/EMAIL porque IA é transversal a
// canais e tem implicação de custo (chave do tenant).
export const P_LLM_CREDENTIALS_MANAGE = "ai:llm_credentials_manage";
export const P_AGENTS_MANAGE = "ai:agents_manage";
export const P_ROUTING_ENGINE_MANAGE = "ai:routing_engine_manage";

// ── Anúncios (Meta Ads / Marketing API) ─────────────────────────────────────
// Grupo próprio, e não dentro de WHATSAPP: tráfego pago não é canal de
// mensagem, e é o único módulo do produto onde uma ação gasta dinheiro do
// cliente de forma imediata e irreversível.
//
// A separação entre MANAGE e ACTIVATE é o que torna seguro expor criação de
// campanha a um agente de IA: com `ads:manage` dá para montar a campanha
// inteira, mas ela nasce e permanece PAUSED. Só `ads:activate` coloca verba
// para rodar — e também governa mudança de orçamento, que é a outra forma de
// gastar mais sem "ativar" nada.
export const P_ADS_VIEW = "ads:view";
export const P_ADS_MANAGE = "ads:manage";
export const P_ADS_ACTIVATE = "ads:activate";
export const P_ADS_CREDENTIALS_MANAGE = "ads:credentials_manage";

// ── Instagram (canal de atendimento) ─────────────────────────────────────────
// As DMs do Instagram são conversa e vivem no Inbox — quem responde precisa de
// `inbox:*`, não de permissão nova. O que ganha chave própria é o que não existe
// no WhatsApp: comentário em post é PÚBLICO, e responder em nome da marca na
// frente de todo mundo é uma decisão diferente de responder no privado.
export const P_INSTAGRAM_MANAGE_CONNECTION = "instagram:manage_connection";
export const P_INSTAGRAM_VIEW_COMMENTS = "instagram:view_comments";
export const P_INSTAGRAM_REPLY_COMMENTS = "instagram:reply_comments";
/**
 * Automações "palavra-chave → DM". Separada de responder comentário porque
 * uma automação fala com centenas de pessoas em nome da marca sem ninguém
 * revisar cada mensagem — é decisão de quem cuida do marketing, não de quem
 * está no atendimento.
 */
export const P_INSTAGRAM_MANAGE_AUTOMATIONS = "instagram:manage_automations";

// ── Redes sociais (publicação) ───────────────────────────────────────────────
/**
 * Agendar e publicar posts, reels e stories no Instagram e no Facebook. Chave
 * própria porque publicar é falar em nome da marca para TODOS os seguidores —
 * decisão de quem cuida das redes, não de quem modera comentário.
 */
export const P_SOCIAL_PUBLISH = "social:publish";
/** Ver os números das contas (alcance, visualizações, seguidores, posts). */
export const P_SOCIAL_VIEW_INSIGHTS = "social:view_insights";
/**
 * Conectar e desconectar contas do TikTok, YouTube e LinkedIn. Mesma régua de
 * `P_INSTAGRAM_MANAGE_CONNECTION`: dar ao LeadConversa o direito de publicar
 * em nome da marca é decisão de admin, não de quem agenda o post.
 */
export const P_SOCIAL_MANAGE_ACCOUNTS = "social:manage_accounts";

// ── Copiloto de call ─────────────────────────────────────────────────────────
// Sugestao de script ao vivo durante a reuniao (extensao do Chrome + gateway).
// `use` e do vendedor: conecta a extensao e ve as proprias calls. `manage` e
// de quem escreve o playbook e calibra quando o copiloto fala — isso muda o que
// TODO vendedor ouve, entao nao e do vendedor. `insights` abre as calls de
// toda a equipe, inclusive transcricao, e por isso fica separada de `use`.
export const P_COPILOT_USE = "copilot:use";
export const P_COPILOT_MANAGE = "copilot:manage";
export const P_COPILOT_INSIGHTS = "copilot:insights";

// ── Assistente (chat que comanda o painel) ───────────────────────────────────
// Uma permissão só: o chat nunca faz mais do que o próprio usuário faria
// clicando — cada tool passa pelo procedure com o RBAC do perfil. O que esta
// permissão controla é o acesso ao chat em si (e ao custo de LLM que ele gera).
export const P_ASSISTANT_USE = "assistant:use";

// ── Cobrança ─────────────────────────────────────────────────────────────────
// Quanto o WhatsApp está custando e se a conta da Meta está pronta para
// enviar. Permissão própria, e não `settings:view`, porque custo é informação
// de dono: quem atende conversa não precisa ver a fatura da empresa, e quem
// cuida do financeiro não precisa de acesso ao atendimento para ver o gasto.
// Sem `manage` de propósito — nada nesta tela muda dinheiro. Quem define modo
// de cobrança e margem somos nós, pelo SuperAdmin.
export const P_BILLING_VIEW = "billing:view";

// ── Usuários ─────────────────────────────────────────────────────────────────
export const P_USERS_VIEW = "users:view";
export const P_USERS_CREATE = "users:create";
export const P_USERS_EDIT = "users:edit";
export const P_USERS_DELETE = "users:delete";
export const P_USERS_MANAGE_ROLES = "users:manage_roles";

// ── Visibilidade de Dados ────────────────────────────────────────────────────
export const P_DATA_PHONE_VISIBLE = "data:phone_visible";
export const P_DATA_EMAIL_VISIBLE = "data:email_visible";

// ── CRM (Funil de Vendas) ────────────────────────────────────────────────────
export const P_CRM_PIPELINES_MANAGE = "crm:pipelines_manage";
export const P_CRM_DEALS_VIEW = "crm:deals_view";
export const P_CRM_DEALS_VIEW_ALL = "crm:deals_view_all";
export const P_CRM_DEALS_CREATE = "crm:deals_create";
export const P_CRM_DEALS_EDIT = "crm:deals_edit";
export const P_CRM_DEALS_DELETE = "crm:deals_delete";
// Atribuir vendedor. Sozinha, vale para as próprias oportunidades e para as de
// quem o usuário gerencia (seller_profiles.managerUserId). Ver assertCanAssignDeal.
export const P_CRM_DEALS_ASSIGN = "crm:deals_assign";
// Escapa do escopo acima: reatribui qualquer oportunidade do tenant.
export const P_CRM_DEALS_ASSIGN_ALL = "crm:deals_assign_all";
export const P_CRM_DEALS_CHANGE_STAGE = "crm:deals_change_stage";
export const P_CRM_TASKS_VIEW = "crm:tasks_view";
export const P_CRM_TASKS_MANAGE = "crm:tasks_manage";
export const P_CRM_REPORTS_VIEW = "crm:reports_view";
export const P_CRM_PRODUCTS_VIEW = "crm:products_view";
export const P_CRM_PRODUCTS_MANAGE = "crm:products_manage";
export const P_CRM_DEAL_PRODUCTS_MANAGE = "crm:deal_products_manage";
export const P_CRM_SELLERS_VIEW = "crm:sellers_view";
export const P_CRM_SELLERS_MANAGE = "crm:sellers_manage";
export const P_CRM_COMMISSIONS_VIEW = "crm:commissions_view";
export const P_CRM_COMMISSIONS_VIEW_ALL = "crm:commissions_view_all";
export const P_CRM_COMMISSIONS_APPROVE = "crm:commissions_approve";
export const P_CRM_VIEWS_SHARE = "crm:views_share";
// Propostas comerciais. VIEW segue o recorte de deals_view_all (sem ele, só
// as propostas das próprias oportunidades). MANAGE = gerar, editar, enviar ao
// gestor e ao cliente. APPROVE = o gestor: aprova, assina, devolve.
export const P_CRM_PROPOSALS_VIEW = "crm:proposals_view";
export const P_CRM_PROPOSALS_MANAGE = "crm:proposals_manage";
export const P_CRM_PROPOSALS_APPROVE = "crm:proposals_approve";
export const P_CRM_PROPOSAL_TEMPLATES_MANAGE = "crm:proposal_templates_manage";
// Conectar/desconectar o Canva da empresa (Configurações → Integrações).
export const P_CRM_CANVA_MANAGE = "crm:canva_manage";
// Fila de prospecção. VIEW = trabalhar a fila (abordar, marcar resultado) e ver
// o relatório — segue o recorte de deals_view_all para ver a fila dos colegas.
// MANAGE = configurar o funil de prospecção, a cadência e os roteiros.
export const P_CRM_PROSPECTING_VIEW = "crm:prospecting_view";
export const P_CRM_PROSPECTING_MANAGE = "crm:prospecting_manage";

// ─── Agenda (reuniões e disponibilidade) ─────────────────────────────────────
// Separada do CRM de propósito: a agenda é sobre o TEMPO das pessoas, e quem
// pode ver a carteira de oportunidades não necessariamente pode ver e ocupar
// a agenda dos colegas.
export const P_AGENDA_VIEW = "agenda:view";
export const P_AGENDA_VIEW_ALL = "agenda:view_all";
export const P_AGENDA_MANAGE = "agenda:manage";
export const P_AGENDA_MANAGE_ALL = "agenda:manage_all";
export const P_AGENDA_AVAILABILITY_MANAGE_ALL = "agenda:availability_manage_all";

// ─── Lista completa ──────────────────────────────────────────────────────────
export const ALL_PERMISSIONS = [
  // Dashboard
  P_DASHBOARD_VIEW,
  // Inbox
  P_INBOX_VIEW, P_INBOX_VIEW_ALL, P_INBOX_SEND_MESSAGE, P_INBOX_SEND_MEDIA,
  P_INBOX_ASSIGN, P_INBOX_MANAGE_LABELS, P_INBOX_MANAGE_REMINDERS, P_INBOX_GENERATE_AI_REPLY,
  // Contatos
  P_CONTACTS_VIEW, P_CONTACTS_VIEW_DETAILS, P_CONTACTS_CREATE, P_CONTACTS_EDIT,
  P_CONTACTS_DELETE, P_CONTACTS_BULK_IMPORT, P_CONTACTS_BULK_DELETE, P_CONTACTS_DELETE_ALL,
  P_CONTACTS_EXPORT, P_CONTACTS_MANAGE_TAGS, P_CONTACTS_MANAGE_SEGMENTS, P_CONTACTS_LEAD_SCORING,
  // WhatsApp
  P_WHATSAPP_VIEW_BROADCASTS, P_WHATSAPP_CREATE_BROADCAST, P_WHATSAPP_EDIT_BROADCAST,
  P_WHATSAPP_SEND_BROADCAST, P_WHATSAPP_DELETE_BROADCAST, P_WHATSAPP_MANAGE_TEMPLATES,
  P_WHATSAPP_SYNC_TEMPLATES, P_WHATSAPP_MANAGE_FLOWS, P_WHATSAPP_MANAGE_AUTOMATIONS,
  P_WHATSAPP_MANAGE_SEQUENCES, P_WHATSAPP_AUTO_ASSIGNMENT, P_WHATSAPP_KNOWLEDGE_BASE,
  P_WHATSAPP_AI_INSIGHTS, P_WHATSAPP_SANDBOX, P_WHATSAPP_OPTIN,
  // Email
  P_EMAIL_VIEW_CAMPAIGNS, P_EMAIL_CREATE_CAMPAIGN, P_EMAIL_EDIT_CAMPAIGN,
  P_EMAIL_SEND_CAMPAIGN, P_EMAIL_SEND_TEST, P_EMAIL_DELETE_CAMPAIGN,
  P_EMAIL_MANAGE_TEMPLATES, P_EMAIL_MANAGE_FLOWS, P_EMAIL_AI_TOOLS,
  P_EMAIL_BRAND_VOICE, P_EMAIL_EXPORT_REPORTS,
  // Relatórios
  P_REPORTS_VIEW_WHATSAPP, P_REPORTS_VIEW_EMAIL, P_REPORTS_VIEW_INBOX,
  P_REPORTS_VIEW_AI_INSIGHTS, P_REPORTS_MESSAGE_TRACER,
  // Configurações
  P_SETTINGS_VIEW, P_SETTINGS_EDIT_WHATSAPP, P_SETTINGS_EDIT_EMAIL,
  P_SETTINGS_MANAGE_WEBHOOKS, P_SETTINGS_OFFICE_HOURS, P_SETTINGS_QUICK_REPLIES,
  P_SETTINGS_EDIT_BOT, P_SETTINGS_MCP_TOKENS,
  // IA (BYOK + Agentes + Routing Engine)
  P_LLM_CREDENTIALS_MANAGE, P_AGENTS_MANAGE, P_ROUTING_ENGINE_MANAGE,
  // Anúncios (Meta Ads)
  P_ADS_VIEW, P_ADS_MANAGE, P_ADS_ACTIVATE, P_ADS_CREDENTIALS_MANAGE,
  // Instagram (canal)
  P_INSTAGRAM_MANAGE_CONNECTION, P_INSTAGRAM_VIEW_COMMENTS, P_INSTAGRAM_REPLY_COMMENTS,
  P_INSTAGRAM_MANAGE_AUTOMATIONS,
  // Redes sociais (publicação, insights e contas fora da Meta)
  P_SOCIAL_PUBLISH, P_SOCIAL_VIEW_INSIGHTS, P_SOCIAL_MANAGE_ACCOUNTS,
  // Copiloto de call
  P_COPILOT_USE, P_COPILOT_MANAGE, P_COPILOT_INSIGHTS,
  // Assistente
  P_ASSISTANT_USE,
  // Cobrança
  P_BILLING_VIEW,
  // Usuários
  P_USERS_VIEW, P_USERS_CREATE, P_USERS_EDIT, P_USERS_DELETE, P_USERS_MANAGE_ROLES,
  // Dados
  P_DATA_PHONE_VISIBLE, P_DATA_EMAIL_VISIBLE,
  // CRM
  P_CRM_PIPELINES_MANAGE,
  P_CRM_DEALS_VIEW, P_CRM_DEALS_VIEW_ALL, P_CRM_DEALS_CREATE, P_CRM_DEALS_EDIT,
  P_CRM_DEALS_DELETE, P_CRM_DEALS_ASSIGN, P_CRM_DEALS_ASSIGN_ALL, P_CRM_DEALS_CHANGE_STAGE,
  P_CRM_TASKS_VIEW, P_CRM_TASKS_MANAGE,
  P_CRM_REPORTS_VIEW,
  P_CRM_PRODUCTS_VIEW, P_CRM_PRODUCTS_MANAGE, P_CRM_DEAL_PRODUCTS_MANAGE,
  P_CRM_SELLERS_VIEW, P_CRM_SELLERS_MANAGE,
  P_CRM_COMMISSIONS_VIEW, P_CRM_COMMISSIONS_VIEW_ALL, P_CRM_COMMISSIONS_APPROVE,
  P_CRM_VIEWS_SHARE,
  P_CRM_PROPOSALS_VIEW, P_CRM_PROPOSALS_MANAGE, P_CRM_PROPOSALS_APPROVE,
  P_CRM_PROPOSAL_TEMPLATES_MANAGE, P_CRM_CANVA_MANAGE,
  P_CRM_PROSPECTING_VIEW, P_CRM_PROSPECTING_MANAGE,
  P_AGENDA_VIEW,
  P_AGENDA_VIEW_ALL,
  P_AGENDA_MANAGE,
  P_AGENDA_MANAGE_ALL,
  P_AGENDA_AVAILABILITY_MANAGE_ALL,
] as const;

export type Permission = (typeof ALL_PERMISSIONS)[number];

// ─── Grupos para UI (checkboxes agrupados) ───────────────────────────────────
export const PERMISSION_GROUPS = [
  {
    key: "dashboard",
    label: "Dashboard",
    permissions: [
      { key: P_DASHBOARD_VIEW, label: "Visualizar dashboard" },
    ],
  },
  {
    key: "inbox",
    label: "Atendimento (Inbox)",
    permissions: [
      { key: P_INBOX_VIEW, label: "Acessar atendimento" },
      { key: P_INBOX_VIEW_ALL, label: "Ver todas as conversas (sem isso, só vê as atribuídas)" },
      { key: P_INBOX_SEND_MESSAGE, label: "Enviar mensagens de texto" },
      { key: P_INBOX_SEND_MEDIA, label: "Enviar mídia (imagem, vídeo, arquivo)" },
      { key: P_INBOX_ASSIGN, label: "Atribuir conversas a agentes" },
      { key: P_INBOX_MANAGE_LABELS, label: "Gerenciar etiquetas de conversa" },
      { key: P_INBOX_MANAGE_REMINDERS, label: "Gerenciar lembretes" },
      { key: P_INBOX_GENERATE_AI_REPLY, label: "Gerar respostas com IA" },
    ],
  },
  {
    key: "contacts",
    label: "Contatos",
    permissions: [
      { key: P_CONTACTS_VIEW, label: "Visualizar contatos" },
      { key: P_CONTACTS_VIEW_DETAILS, label: "Ver detalhes (telefone, e-mail)" },
      { key: P_CONTACTS_CREATE, label: "Criar contatos" },
      { key: P_CONTACTS_EDIT, label: "Editar contatos" },
      { key: P_CONTACTS_DELETE, label: "Excluir contatos" },
      { key: P_CONTACTS_BULK_IMPORT, label: "Importar contatos em massa" },
      { key: P_CONTACTS_BULK_DELETE, label: "Excluir contatos em massa" },
      { key: P_CONTACTS_DELETE_ALL, label: "Excluir todos os contatos" },
      { key: P_CONTACTS_EXPORT, label: "Exportar contatos" },
      { key: P_CONTACTS_MANAGE_TAGS, label: "Gerenciar tags" },
      { key: P_CONTACTS_MANAGE_SEGMENTS, label: "Gerenciar segmentos" },
      { key: P_CONTACTS_LEAD_SCORING, label: "Lead scoring" },
    ],
  },
  {
    key: "whatsapp",
    label: "WhatsApp",
    permissions: [
      { key: P_WHATSAPP_VIEW_BROADCASTS, label: "Visualizar transmissões" },
      { key: P_WHATSAPP_CREATE_BROADCAST, label: "Criar transmissões" },
      { key: P_WHATSAPP_EDIT_BROADCAST, label: "Editar transmissões" },
      { key: P_WHATSAPP_SEND_BROADCAST, label: "Enviar/agendar transmissões" },
      { key: P_WHATSAPP_DELETE_BROADCAST, label: "Excluir transmissões" },
      { key: P_WHATSAPP_MANAGE_TEMPLATES, label: "Gerenciar templates" },
      { key: P_WHATSAPP_SYNC_TEMPLATES, label: "Sincronizar templates com Meta" },
      { key: P_WHATSAPP_MANAGE_FLOWS, label: "Gerenciar fluxos WhatsApp" },
      { key: P_WHATSAPP_MANAGE_AUTOMATIONS, label: "Gerenciar automações" },
      { key: P_WHATSAPP_MANAGE_SEQUENCES, label: "Gerenciar sequências" },
      { key: P_WHATSAPP_AUTO_ASSIGNMENT, label: "Configurar auto-atribuição" },
      { key: P_WHATSAPP_KNOWLEDGE_BASE, label: "Base de conhecimento" },
      { key: P_WHATSAPP_AI_INSIGHTS, label: "Insights de IA" },
      { key: P_WHATSAPP_SANDBOX, label: "Sandbox / Teste" },
      { key: P_WHATSAPP_OPTIN, label: "Links de captação (opt-in)" },
    ],
  },
  {
    key: "email",
    label: "E-mail Marketing",
    permissions: [
      { key: P_EMAIL_VIEW_CAMPAIGNS, label: "Visualizar campanhas" },
      { key: P_EMAIL_CREATE_CAMPAIGN, label: "Criar campanhas" },
      { key: P_EMAIL_EDIT_CAMPAIGN, label: "Editar campanhas" },
      { key: P_EMAIL_SEND_CAMPAIGN, label: "Enviar campanhas" },
      { key: P_EMAIL_SEND_TEST, label: "Enviar e-mail de teste" },
      { key: P_EMAIL_DELETE_CAMPAIGN, label: "Excluir campanhas" },
      { key: P_EMAIL_MANAGE_TEMPLATES, label: "Gerenciar modelos de e-mail" },
      { key: P_EMAIL_MANAGE_FLOWS, label: "Gerenciar fluxos de automação" },
      { key: P_EMAIL_AI_TOOLS, label: "Ferramentas de IA (produtos, públicos)" },
      { key: P_EMAIL_BRAND_VOICE, label: "Voz da marca" },
      { key: P_EMAIL_EXPORT_REPORTS, label: "Exportar relatórios de campanha" },
    ],
  },
  {
    key: "reports",
    label: "Relatórios",
    permissions: [
      { key: P_REPORTS_VIEW_WHATSAPP, label: "Relatórios de WhatsApp" },
      { key: P_REPORTS_VIEW_EMAIL, label: "Relatórios de e-mail" },
      { key: P_REPORTS_VIEW_INBOX, label: "Relatórios do atendimento" },
      { key: P_REPORTS_VIEW_AI_INSIGHTS, label: "Insights de IA" },
      { key: P_REPORTS_MESSAGE_TRACER, label: "Rastreamento de mensagens" },
    ],
  },
  {
    key: "settings",
    label: "Configurações",
    permissions: [
      { key: P_SETTINGS_VIEW, label: "Visualizar configurações" },
      { key: P_SETTINGS_EDIT_WHATSAPP, label: "Editar configuração WhatsApp" },
      { key: P_SETTINGS_EDIT_EMAIL, label: "Editar configuração de e-mail" },
      { key: P_SETTINGS_MANAGE_WEBHOOKS, label: "Gerenciar webhooks" },
      { key: P_SETTINGS_OFFICE_HOURS, label: "Horário de atendimento" },
      { key: P_SETTINGS_QUICK_REPLIES, label: "Respostas rápidas" },
      { key: P_SETTINGS_EDIT_BOT, label: "Comportamento do robô" },
      { key: P_SETTINGS_MCP_TOKENS, label: "Tokens de acesso MCP" },
    ],
  },
  {
    key: "ai",
    label: "Inteligência Artificial",
    permissions: [
      { key: P_LLM_CREDENTIALS_MANAGE, label: "Gerenciar chaves de API (BYOK)" },
      { key: P_AGENTS_MANAGE, label: "Gerenciar agentes IA" },
      { key: P_ROUTING_ENGINE_MANAGE, label: "Configurar Routing Engine" },
    ],
  },
  {
    key: "ads",
    label: "Anúncios (Meta Ads)",
    permissions: [
      { key: P_ADS_VIEW, label: "Ver campanhas, anúncios e gasto" },
      { key: P_ADS_MANAGE, label: "Criar e editar campanhas (nascem pausadas)" },
      { key: P_ADS_ACTIVATE, label: "Ativar anúncios e alterar orçamento (gasta verba)" },
      { key: P_ADS_CREDENTIALS_MANAGE, label: "Conectar a conta de anúncios da Meta" },
    ],
  },
  {
    key: "instagram",
    label: "Instagram e redes sociais",
    permissions: [
      { key: P_INSTAGRAM_VIEW_COMMENTS, label: "Ver comentários dos posts" },
      { key: P_INSTAGRAM_REPLY_COMMENTS, label: "Responder e ocultar comentários (público)" },
      { key: P_INSTAGRAM_MANAGE_AUTOMATIONS, label: "Criar automações de comentário → DM" },
      { key: P_INSTAGRAM_MANAGE_CONNECTION, label: "Conectar a conta do Instagram" },
      { key: P_SOCIAL_PUBLISH, label: "Agendar e publicar posts nas redes sociais e criar links de captação" },
      { key: P_SOCIAL_VIEW_INSIGHTS, label: "Ver os insights das contas e os leads que vieram das redes" },
      { key: P_SOCIAL_MANAGE_ACCOUNTS, label: "Conectar contas do TikTok, YouTube e LinkedIn" },
    ],
  },
  {
    key: "billing",
    label: "Cobrança",
    permissions: [
      { key: P_BILLING_VIEW, label: "Ver o custo das mensagens e a situação da conta na Meta" },
    ],
  },
  {
    key: "users",
    label: "Gestão de Usuários",
    permissions: [
      { key: P_USERS_VIEW, label: "Visualizar usuários" },
      { key: P_USERS_CREATE, label: "Criar usuários" },
      { key: P_USERS_EDIT, label: "Editar usuários" },
      { key: P_USERS_DELETE, label: "Excluir usuários" },
      { key: P_USERS_MANAGE_ROLES, label: "Gerenciar perfis de acesso" },
    ],
  },
  {
    key: "data",
    label: "Visibilidade de Dados",
    permissions: [
      { key: P_DATA_PHONE_VISIBLE, label: "Visualizar telefone dos contatos" },
      { key: P_DATA_EMAIL_VISIBLE, label: "Visualizar e-mail dos contatos" },
    ],
  },
  {
    key: "copilot",
    label: "Copiloto de call",
    permissions: [
      { key: P_COPILOT_USE, label: "Usar o copiloto nas próprias calls (extensão)" },
      { key: P_COPILOT_MANAGE, label: "Editar o playbook e a política de sugestões" },
      { key: P_COPILOT_INSIGHTS, label: "Ver insights e transcrições das calls de toda a equipe" },
    ],
  },
  {
    key: "assistant",
    label: "Assistente",
    permissions: [
      { key: P_ASSISTANT_USE, label: "Usar o Assistente (chat que executa e ensina, dentro das permissões do perfil)" },
    ],
  },
  {
    key: "crm",
    label: "CRM (Funil de Vendas)",
    permissions: [
      { key: P_CRM_DEALS_VIEW, label: "Visualizar oportunidades" },
      { key: P_CRM_DEALS_VIEW_ALL, label: "Ver oportunidades de todos (sem isso, só as próprias)" },
      { key: P_CRM_DEALS_CREATE, label: "Criar oportunidades" },
      { key: P_CRM_DEALS_EDIT, label: "Editar oportunidades" },
      { key: P_CRM_DEALS_DELETE, label: "Excluir oportunidades" },
      { key: P_CRM_DEALS_ASSIGN, label: "Atribuir vendedor (nas próprias e nas da equipe que gerencia)" },
      { key: P_CRM_DEALS_ASSIGN_ALL, label: "Atribuir vendedor em qualquer oportunidade" },
      { key: P_CRM_DEALS_CHANGE_STAGE, label: "Mover de estágio / ganhar / perder" },
      { key: P_CRM_TASKS_VIEW, label: "Visualizar tarefas" },
      { key: P_CRM_TASKS_MANAGE, label: "Gerenciar tarefas" },
      { key: P_CRM_REPORTS_VIEW, label: "Relatórios de vendas" },
      { key: P_CRM_PIPELINES_MANAGE, label: "Gerenciar funis e estágios" },
      { key: P_CRM_PRODUCTS_VIEW, label: "Visualizar catálogo de produtos" },
      { key: P_CRM_PRODUCTS_MANAGE, label: "Gerenciar catálogo (criar, editar, arquivar)" },
      { key: P_CRM_DEAL_PRODUCTS_MANAGE, label: "Vincular produtos às oportunidades" },
      { key: P_CRM_SELLERS_VIEW, label: "Visualizar vendedores e ranking" },
      { key: P_CRM_SELLERS_MANAGE, label: "Gerenciar perfis de vendedores (meta, % comissão)" },
      { key: P_CRM_COMMISSIONS_VIEW, label: "Visualizar comissões próprias" },
      { key: P_CRM_COMMISSIONS_VIEW_ALL, label: "Visualizar comissões de todos" },
      { key: P_CRM_COMMISSIONS_APPROVE, label: "Aprovar / marcar comissões como pagas" },
      { key: P_CRM_VIEWS_SHARE, label: "Compartilhar vistas salvas com a equipe" },
      { key: P_CRM_PROPOSALS_VIEW, label: "Visualizar propostas comerciais" },
      { key: P_CRM_PROPOSALS_MANAGE, label: "Gerar e enviar propostas (nas próprias oportunidades)" },
      { key: P_CRM_PROPOSALS_APPROVE, label: "Aprovar e assinar propostas (gestor)" },
      { key: P_CRM_PROPOSAL_TEMPLATES_MANAGE, label: "Gerenciar modelos de proposta" },
      { key: P_CRM_CANVA_MANAGE, label: "Conectar o Canva da empresa (propostas)" },
      { key: P_CRM_PROSPECTING_VIEW, label: "Fila de prospecção (abordar leads e marcar resultado)" },
      { key: P_CRM_PROSPECTING_MANAGE, label: "Configurar fila de prospecção (cadência e roteiros)" },
    ],
  },
  {
    key: "agenda",
    label: "Agenda (Reuniões)",
    permissions: [
      { key: P_AGENDA_VIEW, label: "Ver a própria agenda" },
      { key: P_AGENDA_VIEW_ALL, label: "Ver a agenda de toda a equipe" },
      { key: P_AGENDA_MANAGE, label: "Marcar e editar reuniões (as próprias)" },
      { key: P_AGENDA_MANAGE_ALL, label: "Marcar reunião na agenda de qualquer pessoa" },
      { key: P_AGENDA_AVAILABILITY_MANAGE_ALL, label: "Definir disponibilidade e bloqueios de outras pessoas" },
    ],
  },
] as const;

// ─── Permissões padrão por perfil ────────────────────────────────────────────

const ADMIN_PERMISSIONS: Permission[] = [...ALL_PERMISSIONS];

const MARKETING_PERMISSIONS: Permission[] = [
  // Dashboard
  P_DASHBOARD_VIEW,
  // Inbox (leitura + envio)
  P_INBOX_VIEW, P_INBOX_VIEW_ALL, P_INBOX_SEND_MESSAGE, P_INBOX_SEND_MEDIA,
  // Contatos (completo)
  P_CONTACTS_VIEW, P_CONTACTS_VIEW_DETAILS, P_CONTACTS_CREATE, P_CONTACTS_EDIT,
  P_CONTACTS_EXPORT, P_CONTACTS_MANAGE_TAGS, P_CONTACTS_MANAGE_SEGMENTS, P_CONTACTS_LEAD_SCORING,
  // WhatsApp (visualizar broadcasts + templates)
  P_WHATSAPP_VIEW_BROADCASTS, P_WHATSAPP_MANAGE_TEMPLATES,
  // Email (tudo)
  P_EMAIL_VIEW_CAMPAIGNS, P_EMAIL_CREATE_CAMPAIGN, P_EMAIL_EDIT_CAMPAIGN,
  P_EMAIL_SEND_CAMPAIGN, P_EMAIL_SEND_TEST, P_EMAIL_DELETE_CAMPAIGN,
  P_EMAIL_MANAGE_TEMPLATES, P_EMAIL_MANAGE_FLOWS, P_EMAIL_AI_TOOLS,
  P_EMAIL_BRAND_VOICE, P_EMAIL_EXPORT_REPORTS,
  // Relatórios
  P_REPORTS_VIEW_WHATSAPP, P_REPORTS_VIEW_EMAIL, P_REPORTS_VIEW_INBOX,
  // Anúncios — marketing é quem opera tráfego pago, então recebe até a
  // ativação. Fica de fora só a credencial: chave com custo atrelado é do
  // admin, mesma régua de P_LLM_CREDENTIALS_MANAGE.
  P_ADS_VIEW, P_ADS_MANAGE, P_ADS_ACTIVATE,
  // Instagram — marketing cuida das redes sociais, então responde comentário
  // e monta as automações de DM. Conectar a conta continua sendo do admin.
  P_INSTAGRAM_VIEW_COMMENTS, P_INSTAGRAM_REPLY_COMMENTS, P_INSTAGRAM_MANAGE_AUTOMATIONS,
  // Agendar post e acompanhar os números é o trabalho de marketing nas redes.
  P_SOCIAL_PUBLISH, P_SOCIAL_VIEW_INSIGHTS,
  // Dados visíveis
  P_DATA_PHONE_VISIBLE, P_DATA_EMAIL_VISIBLE,
  // Conectar IA (MCP) — o token herda só o RBAC do próprio usuário
  P_SETTINGS_MCP_TOKENS,
  // Assistente — quem cuida de campanha e e-mail ganha o chat também.
  P_ASSISTANT_USE,
];

const COMERCIAL_PERMISSIONS: Permission[] = [
  // Dashboard
  P_DASHBOARD_VIEW,
  // Inbox (completo + ver todas)
  P_INBOX_VIEW, P_INBOX_VIEW_ALL, P_INBOX_SEND_MESSAGE, P_INBOX_SEND_MEDIA,
  P_INBOX_ASSIGN, P_INBOX_MANAGE_LABELS, P_INBOX_MANAGE_REMINDERS, P_INBOX_GENERATE_AI_REPLY,
  // Contatos (CRUD sem bulk delete/delete all)
  P_CONTACTS_VIEW, P_CONTACTS_VIEW_DETAILS, P_CONTACTS_CREATE, P_CONTACTS_EDIT,
  P_CONTACTS_EXPORT, P_CONTACTS_MANAGE_TAGS,
  // WhatsApp (visualizar broadcasts)
  P_WHATSAPP_VIEW_BROADCASTS,
  // Relatórios
  P_REPORTS_VIEW_WHATSAPP, P_REPORTS_VIEW_INBOX,
  // Dados visíveis
  P_DATA_PHONE_VISIBLE, P_DATA_EMAIL_VISIBLE,
  // Copiloto — o vendedor usa nas proprias calls; playbook e insights da
  // equipe ficam com o admin.
  P_COPILOT_USE,
  // CRM (vendedor: gerencia as próprias oportunidades)
  // ASSIGN sem ASSIGN_ALL = repassa as próprias e, se for gerente, as da equipe.
  P_CRM_DEALS_VIEW, P_CRM_DEALS_CREATE, P_CRM_DEALS_EDIT,
  P_CRM_DEALS_ASSIGN, P_CRM_DEALS_CHANGE_STAGE,
  P_CRM_TASKS_VIEW, P_CRM_TASKS_MANAGE,
  P_CRM_REPORTS_VIEW,
  P_CRM_PRODUCTS_VIEW, P_CRM_DEAL_PRODUCTS_MANAGE,
  P_CRM_SELLERS_VIEW, P_CRM_COMMISSIONS_VIEW,
  // Propostas: gera e envia as próprias. Aprovar/assinar é do gestor.
  P_CRM_PROPOSALS_VIEW, P_CRM_PROPOSALS_MANAGE,
  // Fila de prospecção: o SDR trabalha a própria fila.
  P_CRM_PROSPECTING_VIEW,
  // Agenda — o vendedor vê a agenda do time (precisa disso para marcar reunião
  // com o colega certo) e marca reunião, inclusive na agenda de outra pessoa:
  // é exatamente o que a SDR faz ao agendar para a closer. O que fica de fora é
  // mexer na disponibilidade e nos bloqueios dos outros, que é decisão de
  // gestão sobre o tempo alheio.
  P_AGENDA_VIEW, P_AGENDA_VIEW_ALL, P_AGENDA_MANAGE, P_AGENDA_MANAGE_ALL,
  // Conectar IA (MCP) — o token herda só o RBAC do próprio usuário
  P_SETTINGS_MCP_TOKENS,
  // Assistente — o vendedor comanda o próprio dia pelo chat.
  P_ASSISTANT_USE,
];

const ATENDENTE_PERMISSIONS: Permission[] = [
  // Dashboard
  P_DASHBOARD_VIEW,
  // Inbox (sem view_all = só conversas atribuídas)
  P_INBOX_VIEW, P_INBOX_SEND_MESSAGE, P_INBOX_SEND_MEDIA,
  P_INBOX_MANAGE_REMINDERS,
  // Contatos (apenas visualizar, sem detalhes por padrão)
  P_CONTACTS_VIEW,
  // Configurações (apenas quick replies para uso no chat)
  P_SETTINGS_QUICK_REPLIES,
  // Instagram — vê a fila de comentários (o contexto costuma estar lá), mas
  // responder em público, em nome da marca, fica para quem o admin liberar.
  P_INSTAGRAM_VIEW_COMMENTS,
  // Assistente — responde "como faço" e executa só o que o perfil já pode.
  P_ASSISTANT_USE,
];

export type SystemRoleSlug = "admin" | "marketing" | "comercial" | "atendente";

export const SYSTEM_ROLES: {
  slug: SystemRoleSlug;
  name: string;
  description: string;
  permissions: Permission[];
}[] = [
  {
    slug: "admin",
    name: "Administrador",
    description: "Acesso total ao sistema. Pode gerenciar usuários, configurações e todos os recursos.",
    permissions: ADMIN_PERMISSIONS,
  },
  {
    slug: "marketing",
    name: "Marketing",
    description: "Acesso a e-mail marketing, campanhas, contatos e relatórios. Pode criar e disparar campanhas de e-mail.",
    permissions: MARKETING_PERMISSIONS,
  },
  {
    slug: "comercial",
    name: "Comercial",
    description: "Acesso ao atendimento, contatos e visualização de transmissões. Não pode disparar mensagens em massa nem acessar e-mail marketing.",
    permissions: COMERCIAL_PERMISSIONS,
  },
  {
    slug: "atendente",
    name: "Atendente",
    description: "Acesso apenas ao atendimento de conversas atribuídas. Dados de contato ficam ocultos por padrão.",
    permissions: ATENDENTE_PERMISSIONS,
  },
];

export const DEFAULT_ROLE_PERMISSIONS: Record<SystemRoleSlug, Permission[]> = {
  admin: ADMIN_PERMISSIONS,
  marketing: MARKETING_PERMISSIONS,
  comercial: COMERCIAL_PERMISSIONS,
  atendente: ATENDENTE_PERMISSIONS,
};
